import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InboxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"inbox"}/>
}
